import {createType, createAction} from 'store/utils';

const prefix = 'BUDGET';

export const UPDATE_BUDGET = createType(prefix, 'UPDATE');
export const updateBudget = (payload: BudgetState): Action => createAction(UPDATE_BUDGET, payload);
